<template>
  <div>
    <b-modal id="modal-detail" size="xl" centered :title="$store.state.form.detailPelamar" header-bg-variant="info" header-text-variant="light">
      <b-tabs content-class="mt-3" align="center">
        <b-tab :title="$store.state.form.profilPelamar">
          <detail-tab-profil :dataProfil="dataProfil" />
        </b-tab>
        <b-tab :title="$store.state.form.riwayatPendidikan">
          <detail-tab-pendidikan :dataRiwayat="dataRiwayat" />
        </b-tab>
        <b-tab :title="$store.state.form.pengalamanKerja">
          <detail-tab-kerja :dataPengalaman="dataPengalaman" />
        </b-tab>
        <b-tab :title="$store.state.form.lampiran">
          <detail-tab-lampiran :kebutuhanPelamar="kebutuhanPelamar" />
        </b-tab>
        <b-tab :title="$store.state.form.status">
          <detail-tab-status :data="data" :dataRiwayat="dataRiwayat" @alertFromChild="triggerAlert($event)" />
        </b-tab>
      </b-tabs>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-detail')">
          {{ $store.state.form.batal }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import detailTabProfil from "./detailTabProfil.vue";
import detailTabPendidikan from "./detailTabPendidikan.vue";
import detailTabKerja from "./detailTabKerja.vue";
import detailTabLampiran from "./detailTabLampiran.vue";
import detailTabStatus from "./detailTabStatus.vue";
import moment from "moment";
moment.locale("id");
export default {
  name: "modalDetail",
  props: ["data", "detail"],
  components: {
    detailTabProfil,
    detailTabPendidikan,
    detailTabKerja,
    detailTabLampiran,
    detailTabStatus,
  },
  data() {
    return {
      dataRiwayat: [],
      dataPengalaman: [],
      dataProfil: [],
      kebutuhanPelamar: [],
    };
  },
  watch: {
    detail: function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.getDetail();
      }
    },
  },
  methods: {
    async getDetail() {
      let vm = this;
      let id = vm.data.postLokerId;
      // let status = vm.data.statusPostLoker;
      let listDetail = await vm.$axios.get("postLoker/detailListByStatus/" + id);
      console.log(listDetail.data.data, "hi", vm.data);
      vm.dataRiwayat = listDetail.data.data[0].riwayatPendidikan;
      vm.dataPengalaman = listDetail.data.data[0].pengalamanKerja;
      vm.dataProfil = listDetail.data.data[0];
      vm.kebutuhanPelamar = listDetail.data.data[0].kebutuhanPelamar;
      vm.dataProfil.tglLahir = moment(vm.dataProfil.tanggalLahirPengirim).format("LL");
      vm.dataProfil.tglMasuk = vm.dataProfil.tanggalMasukLamaran ? moment(vm.dataProfil.tanggalMasukLamaran).format("LL") : moment().format("LL");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$emit("alertFromChild", {
        variant: event.variant,
        msg: event.msg,
        showing: event.showing,
      });
    },
  },
};
</script>
